export const SN_PRODUCT = 'product'
export const PRODUCT_LIST_UPDATED = SN_PRODUCT + '/LIST_UPDATED'
export const PRODUCT_FILTER_UPDATED = SN_PRODUCT + '/FILTER_UPDATED'
export const PRODUCT_QUERY_UPDATED = SN_PRODUCT + '/QUERY_UPDATED'
export const PRODUCT_FILTERS_UPDATED = SN_PRODUCT + '/FILTERS_UPDATED'
export const PRODUCT_ALL_FILTERS_UPDATED = SN_PRODUCT + '/ALL_FILTERS_UPDATED'
export const PRODUCT_THRESHOLD_UPDATED = SN_PRODUCT + '/THRESHOLD_UPDATED'
